type AudioPlayerSkipButtonProps = {
  direction: "back" | "forward";
  disabled?: boolean;
  onSkip: (offsetSeconds: number) => void;
  skipSeconds: number;
};

const SKIP_ARC_PATH =
  "M8 0C12.9706 0 17 4.02944 17 9C17 12.043 15.489 14.733 13.1807 16.3604C12.7293 16.6786 12.1053 16.5705 11.7871 16.1191C11.469 15.6678 11.577 15.0438 12.0283 14.7256C13.828 13.4568 15 11.3653 15 9C15 5.13401 11.866 2 8 2C6.36582 2.00006 4.86362 2.56073 3.67188 3.5H4.5C5.05228 3.5 5.5 3.94772 5.5 4.5C5.5 5.05228 5.05228 5.5 4.5 5.5H1C0.447715 5.5 0 5.05228 0 4.5V1.5C0 0.947715 0.447715 0.5 1 0.5C1.55228 0.5 2 0.947715 2 1.5V2.29199C3.59152 0.867635 5.69479 6.36379e-05 8 0Z";

/**
 * Circular skip arrow with the skip amount set beside it. The forward variant
 * mirrors the arc only: mirroring the whole glyph would reverse the digits.
 */
function SkipIcon({ direction }: { direction: "back" | "forward" }) {
  const isBack = direction === "back";

  return (
    <svg
      aria-hidden="true"
      className="size-6 opacity-50 transition-opacity group-hover:opacity-100"
      fill="currentColor"
      viewBox="0 0 22 19"
    >
      <path
        d={SKIP_ARC_PATH}
        transform={isBack ? "translate(5 0)" : "translate(17 0) scale(-1 1)"}
      />
      <g transform={isBack ? "translate(0 8.07)" : "translate(8.88 8.07)"}>
        <path d="M2.016 10.43V1.624H0V0H3.92V10.43H2.016Z" />
        <path d="M9.39848 10.598C8.84782 10.598 8.32048 10.4953 7.81648 10.29C7.32182 10.0847 6.89248 9.79533 6.52848 9.422C6.17382 9.03933 5.93115 8.58667 5.80048 8.064L7.45248 7.476C7.61115 7.952 7.86782 8.30667 8.22248 8.54C8.57715 8.764 8.96915 8.876 9.39848 8.876C9.75315 8.876 10.0658 8.80133 10.3365 8.652C10.6165 8.49333 10.8312 8.27867 10.9805 8.008C11.1298 7.728 11.2045 7.406 11.2045 7.042C11.2045 6.678 11.1252 6.36067 10.9665 6.09C10.8172 5.81933 10.6072 5.60933 10.3365 5.46C10.0658 5.30133 9.75315 5.222 9.39848 5.222C9.03448 5.222 8.70315 5.30133 8.40448 5.46C8.11515 5.61867 7.90515 5.84733 7.77448 6.146L6.22048 5.796L7.04648 0H12.7305V1.61H7.80248L8.51648 0.784001L7.92848 5.152L7.38248 4.704C7.64382 4.32133 7.96115 4.04133 8.33449 3.864C8.71715 3.68667 9.17915 3.598 9.72048 3.598C10.4112 3.598 11.0085 3.74733 11.5125 4.046C12.0258 4.34467 12.4225 4.75067 12.7025 5.264C12.9825 5.77733 13.1225 6.37 13.1225 7.042C13.1225 7.714 12.9592 8.32067 12.6325 8.862C12.3058 9.40333 11.8625 9.828 11.3025 10.136C10.7425 10.444 10.1078 10.598 9.39848 10.598Z" />
      </g>
    </svg>
  );
}

function AudioPlayerSkipButton({
  direction,
  disabled = false,
  onSkip,
  skipSeconds,
}: AudioPlayerSkipButtonProps) {
  const isBack = direction === "back";

  return (
    <button
      aria-label={
        isBack
          ? `Rewind ${skipSeconds} seconds`
          : `Forward ${skipSeconds} seconds`
      }
      className="group flex size-6 shrink-0 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-new-beginnings-base disabled:cursor-not-allowed disabled:opacity-50"
      disabled={disabled}
      onClick={() => onSkip(isBack ? -skipSeconds : skipSeconds)}
      type="button"
    >
      <SkipIcon direction={direction} />
    </button>
  );
}

export { AudioPlayerSkipButton };
